import { render, staticRenderFns } from "./XAside.vue?vue&type=template&id=2ee68ca0&"
import script from "./XAside.vue?vue&type=script&lang=js&"
export * from "./XAside.vue?vue&type=script&lang=js&"
import style0 from "./XAside.vue?vue&type=style&index=0&id=2ee68ca0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports